"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModActionStatus = exports.ModAction = exports.ModStatus = void 0;
var ModStatus;
(function (ModStatus) {
    ModStatus["DRAFT"] = "DRAFT";
    ModStatus["SUBMITTED"] = "SUBMITTED";
    ModStatus["APPROVED"] = "APPROVED";
    ModStatus["PUBLISHED"] = "PUBLISHED";
    ModStatus["REJECTED"] = "REJECTED";
    ModStatus["CHANGES_NEEDED"] = "CHANGES_NEEDED";
    ModStatus["IN_REVIEW"] = "IN_REVIEW";
})(ModStatus = exports.ModStatus || (exports.ModStatus = {}));
var ModAction;
(function (ModAction) {
    ModAction["APPROVE"] = "APPROVE";
    ModAction["PUBLISH"] = "PUBLISH";
    ModAction["REJECT"] = "REJECT";
    ModAction["SUBMIT"] = "SUBMIT";
    ModAction["RECALL"] = "RECALL";
    ModAction["REQUEST_CHANGES"] = "REQUEST_CHANGES";
    ModAction["UNPUBLISH"] = "UNPUBLISH";
    ModAction["REMOVE"] = "REMOVE";
    ModAction["COMMENT"] = "COMMENT";
    ModAction["RECOMMEND"] = "RECOMMEND";
    ModAction["UNRECOMMEND"] = "UNRECOMMEND";
    ModAction["LOCK"] = "LOCK";
    ModAction["UNLOCK"] = "UNLOCK";
    ModAction["CLEAR_REPORTS"] = "CLEAR_REPORTS";
    ModAction["CREATE_NEW_VERSION"] = "CREATE_NEW_VERSION";
    ModAction["AUTO_PUBLISHING_ENABLE"] = "AUTO_PUBLISHING_ENABLE";
    ModAction["AUTO_PUBLISHING_DISABLE"] = "AUTO_PUBLISHING_DISABLE";
})(ModAction = exports.ModAction || (exports.ModAction = {}));
var ModActionStatus;
(function (ModActionStatus) {
    ModActionStatus["SUCCEEDED"] = "SUCCEEDED";
    ModActionStatus["FAILED"] = "FAILED";
    ModActionStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(ModActionStatus = exports.ModActionStatus || (exports.ModActionStatus = {}));
//# sourceMappingURL=common.js.map